const AppConfig = {
  authEndpoint: process.env.REACT_APP_AUTH_HOST
};

export { AppConfig };
